import { EVENT } from 'lib/segment/const'

export const RECOMMENDED_LAYER = {
  personalization: 'just-for-you',
  upSell: 'people-also-bought',
  similar: 'similar',
}

export const PDP_WISHLIST_REF_TYPE = {
  product: 'pdp',
  related: 'pdp_complete_look',
  similar: 'pdp_similar_products',
  personalization: 'pdp_just_for_you',
  upSell: 'pdp_also_bought',
  virtualTryOn: 'virtual_try_on',
}

export const PDP_INTERACT_ELEM_EVENT_NAME = {
  careInstruction: EVENT.productCareInstructionViewed,
  detailView: EVENT.productDetailViewed,
  impression: EVENT.productImpression,
  interSizing: EVENT.productInternationalSizingViewed,
  material: EVENT.productMaterialViewed,
  sizeGuide: EVENT.productSizeGuideViewed,
  shopLook: EVENT.productShopTheLookIconClicked,
  sustainable: EVENT.productSustainabilityViewed,
  sustainableLink: EVENT.sustainabilityLookbookView,
}

export const ADDITIONAL_RELATED_SECTIONS = ['similar', 'personalization']

export const ADDITIONAL_RELATED_SECTIONS_SWAPPED = ['similar', 'upSell']

export const RATING_FIT_VALUES_ENUM = {
  LOOSE: 'loose',
  TRUE_TO_SIZE: 'true_to_size',
  TIGHT: 'tight',
}
